import { useState, useRef, useEffect, SetStateAction } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Col, Row, FormGroup, Button, Form, Modal } from 'react-bootstrap';
import { Table, TBody, TCell, TGroup, THeader, TRow, ThCell } from '../../components/Table/Table';
import { Label } from '../../components/Label';
import { Autocomplete, AutocompleteRenderInputParams, Box, CircularProgress, TextField } from '@mui/material';
import { FillPen } from '../../components/Icons';
import _ from 'lodash';
import './style.css';
import AlertMessage from '../../components/Alert';
import DynamicTable from '../../components/DynamicTable';
import { DeleteModal } from '../../components/ModalDelete';

interface Risco {
    id: string;
    nome: string;
    categoria: any;
}

interface Exame {
    id: string;
    label: string;
}

export function VincularTabelas() {
    const [isLoading, setIsLoading] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [selectedTable, setSelectedTable]: any = useState(null);
    const [loading, setLoading] = useState(false);
    const [riscoSelecionadoParaTabela, setRiscoSelecionadoParaTabela]: any = useState(null);
    const [listaDeRiscos, setListaDeRiscos] = useState<Risco[]>([]);
    const [listaDeTabelas, setListaDeTabelas] = useState<any>([]);
    const [riscoTabela, setRiscoTabela] = useState<any>([]);
    
    const [showModal, setShowModal] = useState(false);
    const [selectedRisco, setSelectedRisco] = useState(null);
    const [selectedTabela, setSelectedTabela]: any = useState(null);
    const [dadosTabela, setDadosTabela] = useState<any[]>([]);

    useEffect(() => {
        if (riscoSelecionadoParaTabela) {
            fetchRiscosPorTabela();
            handleSearchTabelaPadrao();
        } else {
            setRiscoTabela([]);
        }
    }, [riscoSelecionadoParaTabela]);
    const fetchRiscos = async (inputValue: string) => {
        if (!inputValue) return;
        setLoading(true);
        try {
            const response = await api.get(`/buscar-riscos/${inputValue}`);
            setListaDeRiscos(response.data.map((risco: any) => ({ id: risco.id, nome: risco.nome, categoria: risco.AteBaseRiscosCat.categoria })));
        } catch (error) {
            console.error("Erro ao buscar riscos:", error);
            setListaDeRiscos([]);
        } finally {
            setLoading(false);
        }
    };

    const handleSearchTabelaPadrao= async () => {
        const response = await api.get('buscar-tabela-padrao');
        const responseData = response.data[0];
        
        setSelectedTable(responseData);

    }

    const fetchTabelasDinamicas = async (inputValue: string) => {
        if (!inputValue) return;
        setLoading(true);
        try {
            const response = await api.post(`/buscar-tabela-dinamica-input/${inputValue}`);
            setListaDeTabelas(response.data);
        } catch (error) {
            console.error("Erro ao buscar riscos:", error);
            setListaDeRiscos([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchRiscosPorTabela = async () => {
        try {
            const response = await api.post(`listar-risco-tabela/${riscoSelecionadoParaTabela.id}`)
            const responseData = response.data;
            console.log("🚀 ~ fetchRiscosPorTabela ~ responseData:", responseData)

            if (responseData.dadosTabela.length == 0 && responseData.dadosTabela.length == 0) {
                console.log('teste')
                setRiscoTabela([]);
            } else {
                setRiscoTabela(responseData);
            }
            

        } catch (error) {
            console.log(error)
        }
    }

    const handleDeleteConfirm = () => {
        fetchRiscosPorTabela();
    }

    const handleEdit = (risco: any, tabelaId: any) => {
        const vinculoTabela = riscoTabela.tabela.find((tabela: { id: any; id_risco: any; }) => tabela.id_risco == risco.id_risco && tabela.id == tabelaId);
        

        if (vinculoTabela) {
            const tabelaCorrespondente = riscoTabela.dadosTabela.filter((dado: { id: any; }) => dado.id == vinculoTabela.id_tabela);

            if (tabelaCorrespondente.length > 0) {
                setSelectedTabela(tabelaCorrespondente[0]);
            }
        }

        setSelectedRisco(risco);
        setShowModal(true);
    }

    const handleActivate = async (id: number) => {
        try {
            const response = await api.post(`atualizar-padrao-risco-tabela/${id}`);

            if (response.status == 200) {
                setAlert({ message: 'Padrão atualizado com sucesso!', variant: 'success', show: true });
                fetchRiscosPorTabela();
            }

        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
            <Load isLoading={isLoading} /><Sidebar /><Header route='./' /><Main>
                <CardContent style={{ padding: '1px !important', margin: 0 }}>
                    <Row>
                        <Col md={6}>
                            <FormGroup className='form-group-dsg'>
                                <Label title="RISCOS (DIGITE E SELECIONE)" htmlFor="exa" />
                                <Autocomplete
                                    value={riscoSelecionadoParaTabela}
                                    onChange={(event, newValue: any) => {
                                        setSelectedTable(null);
                                        setRiscoSelecionadoParaTabela(newValue);
                                    }}
                                    onInputChange={(event, newInputValue) => {
                                        fetchRiscos(newInputValue);
                                    }}
                                    noOptionsText="Digite e selecione"
                                    style={{ width: '100%', height: '80px', maxHeight: '100px' }}
                                    getOptionLabel={(option) => option ? option.nome + ' - ' + option.categoria : ""}
                                    renderInput={(params) => <TextField {...params} label="" />}
                                    options={listaDeRiscos}
                                    isOptionEqualToValue={(option, value) => option.id === value.id} />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup className='form-group-dsg'>
                                <Label title="TABELAS (DIGITE E SELECIONE)" htmlFor="exa" />
                                <Autocomplete
                                    key={selectedTable ? selectedTable.id : 'empty'}
                                    value={selectedTable}
                                    noOptionsText="Digite e selecione"
                                    style={{ width: '100%', height: '40px' }}
                                    onChange={(event, newValue: any) => {
                                        setSelectedTable(newValue);
                                    }}
                                    onInputChange={(event, newInputValue) => {
                                        fetchTabelasDinamicas(newInputValue);
                                    }}
                                    getOptionLabel={(option: any) => option.nome}
                                    renderInput={(params) => <TextField {...params} label="" />}
                                    options={listaDeTabelas}
                                    isOptionEqualToValue={(option, value) => option.id == value.id} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className='nameInput'>
                        {selectedTable && (
                            <DynamicTable
                                type={selectedTable.tipo}
                                headerColor={selectedTable.cor}
                                riscoSelecionado={riscoSelecionadoParaTabela}
                                tabelaSelecionada={selectedTable}
                                selectedRisco={selectedRisco}
                                fetchRiscosPorTabela={fetchRiscosPorTabela}
                            />
                        )}
                    </Row>
                    <Row>
                        {riscoSelecionadoParaTabela && (
                            <>
                                <div style={{marginBottom: '10px', padding: '0 !important'}}>
                                    <Label title='Tabelas Cadastradas' htmlFor={''} />
                                </div>
                                <Table>
                                    <THeader>
                                        <ThCell>Código</ThCell>
                                        <ThCell>Risco</ThCell>
                                        <ThCell>Tabela</ThCell>
                                        <ThCell>Ação</ThCell>
                                    </THeader>
                                    <TBody>
                                        <TGroup>
                                            {riscoTabela.tabela && riscoTabela.tabela.map((riscoT: any, index: number) => {
                                                const tabelaCorrespondente = riscoTabela.dadosTabela.find((dado: any) => dado.tipo == riscoT.tipo_tabela && dado.id == riscoT.id_tabela);

                                                return (
                                                    <TRow key={index}>
                                                        <TCell>{riscoT.id}</TCell>
                                                        <TCell>{riscoT.risco}</TCell>
                                                        <TCell>{tabelaCorrespondente ? tabelaCorrespondente.nome : 'N/A'}</TCell>
                                                        <TCell>
                                                            <Button variant='outline-primary' className='btn-outline-main' onClick={() => handleEdit(riscoT, riscoT.id)}>
                                                                Editar
                                                                <FillPen />
                                                            </Button>
                                                            <DeleteModal
                                                                endpoint='excluir-risco-tabela'
                                                                onConfirm={handleDeleteConfirm}
                                                                requestBody={{ id: riscoT.id }} />
                                                            {riscoT.ativado == 1 ? (
                                                                <Button style={{ backgroundColor: 'transparent', border: '1px solid', borderColor: 'green', color: 'green' }}>
                                                                    Ativado
                                                                </Button>
                                                            ) : (
                                                                <Button style={{ backgroundColor: 'transparent', border: '1px solid', borderColor: 'gray', color: 'gray' }} onClick={() => handleActivate(riscoT.id)}>
                                                                    Ativar
                                                                </Button>
                                                            )}
                                                        </TCell>
                                                    </TRow>
                                                );
                                            })}
                                        </TGroup>
                                    </TBody>
                                </Table>
                            </>
                        )}


                    </Row>
                </CardContent>
                <Modal size='xl' show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                        <b>Editar Dados</b>
                    </Modal.Header>
                    <Modal.Body>
                        {selectedRisco && selectedTabela && (
                            <DynamicTable
                                type={selectedTabela.tipo}
                                headerColor={selectedTabela.cor}
                                riscoSelecionado={selectedRisco}
                                selectedRisco={selectedRisco}
                                edit={true}
                                fetchRiscosPorTabela={fetchRiscosPorTabela} // Passar a função como prop
                                setShowModal={setShowModal} // Passar a função setShowModal como prop
                            />
                        )}
                    </Modal.Body>
                </Modal>


                <AlertMessage
                    show={alert.show}
                    message={alert.message}
                    variant={alert.variant}
                    onClose={() => setAlert({ ...alert, show: false })} />
            </Main>
        </>
    );
}